import styled from 'styled-components';

import StyledDefaultVariant from './StyledDefaultVariant';

export default styled(StyledDefaultVariant)`
	color: var(--dark-text);
	min-height: calc(var(--radius) * 2);
	& > span {
		color: var(--dark-text);
	}
	b {
		--radius: 1.6rem;
		background-color: var(--cd-color);
		border-radius: var(--radius);
		padding: calc(var(--radius) / 8) var(--radius);
		color: var(--negative-text);
	}
`;
